export const ADORNMENT_ICON_SIZE = {
  SMALL: 's',
  LARGE: 'l',
} as const;
